"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import useOpenData from "@/shared/utils/useOpenData";
import { formatLivePrice } from "@/shared/utils/openData";
import sweatIcon from "@public/sweat_logo_only.svg";
import s from "@/[locale]/token/styles.module.css";

export default function LivePrice() {
  const t = useTranslations("Token");
  const data = useOpenData();
  const price = formatLivePrice(data.sweatPrice, data.status);

  return (
    <div
      className={s.exchangesContent}
      data-price-state={price ? "available" : "unavailable"}
    >
      <div className={s.todayPrice}>
        {price && (
          <>
            {t("todayPriceTitle")}{" "}
            <div className={s.liveLabel}>
              <div className={s.liveTick} />
              LIVE
            </div>
          </>
        )}
      </div>
      <div className={s.tokenExchangePriceToUSD}>
        {price && (
          <>
            <div className={s.oneToken}>
              <Image src={sweatIcon} alt="Sweat minimalistic logo" />1
            </div>
            <div className={s.amountOfUSDForOneToken}>
              = <span>{price} USD</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
